// extracted by mini-css-extract-plugin
export default {"terms_of_service":"TermsOfUse_terms_of_service__da6vk"};